import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FilesService } from './files.service';

@NgModule({
  imports: [CommonModule],
  declarations: [],
})
export class FilesModule {
  static forRoot(): ModuleWithProviders<FilesModule> {
    return {
      ngModule: FilesModule,
      providers: [FilesService],
    };
  }
}
